import { IRootState } from "../../../redux/root.reducer";

export const ITEMS_PER_PAGE_ALL = -1;
const MAX_ITEMS_LIMIT = 10000;

export const selectFiltersAndPagination = (state: IRootState) => {
    const limit = state.trackedList.table.pagination.itemsPerPage;

    return {
        query: state.trackedList.table.searchQuery,
        limit: limit === ITEMS_PER_PAGE_ALL ? MAX_ITEMS_LIMIT : limit,
        offset:
            limit === ITEMS_PER_PAGE_ALL
                ? 0
                : (state.trackedList.table.pagination.currentPage - 1) * limit,
        sortField: state.trackedList.table.sorting.column,
        sortDirection: state.trackedList.table.sorting.order,
    };
};
